import { makeStyles, Step, StepConnector, StepLabel, Stepper, styled } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => {
  return {
    stepperContainerCourse: {
      background: "transparent",
      width: "100%",
      padding: 0
    },
    stepperContainerSurvey: {
      background: "transparent",
      width: "100%",
      padding: 0,
      gap: "1rem",
      marginRight: "1rem",
      "& .MuiStepLabel-alternativeLabel": {
        display: "none"
      }
    }
  };
});

const CustomConnector = styled(StepConnector)(({ theme, type }) => ({
  [`&.MuiStepConnector-alternativeLabel`]: {
    top: 10,
    left: "calc(-50%)",
    right: "calc(50%)"
  },
  [`&.MuiStepConnector-active`]: {
    [`& .MuiStepConnector-line`]: {
      borderColor: type === "course" ? theme.palette.primary.main : theme.palette.secondary.main
    }
  },
  [`&.MuiStepConnector-completed`]: {
    [`& .MuiStepConnector-line`]: {
      borderColor: type === "course" ? theme.palette.primary.main : theme.palette.secondary.main
    }
  },
  [`& .MuiStepConnector-line`]: {
    borderColor: theme.palette.grey[400],
    borderTopWidth: "0.5rem",
    borderRadius: 10
  }
}));

const CustomStepIconRoot = styled("div")(({ theme, ownerstate }) => ({
  visibility: ownerstate.number === 0 ? "hidden" : "inherit",
  color: theme.palette.grey[400],
  display: "flex",
  height: 27,
  zIndex: 10,
  alignItems: "center",
  ...((ownerstate.active || ownerstate.completed) && {
    color: theme.palette.primary.main
  }),
  "& .CustomStepIcon-circle": {
    width: "1.25rem",
    height: "1.25rem",
    borderRadius: "50%",
    backgroundColor: "currentColor"
  }
}));

function CustomStepIcon({ active, className, completed, number }) {
  return (
    <CustomStepIconRoot ownerstate={{ active, completed, number }} className={className}>
      <div className="CustomStepIcon-circle" />
    </CustomStepIconRoot>
  );
}

const StepProgressBar = ({ activeStep, stepNumber, className, type }) => {
  const classes = useStyles({ type });
  const steps = [];
  for (let i = 0; i < stepNumber + 1; i += 1) {
    steps.push(
      <Step key={i}>
        <StepLabel StepIconComponent={props => CustomStepIcon({ ...props, number: i })} />
      </Step>
    );
  }

  return (
    <Stepper
      className={`${
        type === "course" ? classes.stepperContainerCourse : classes.stepperContainerSurvey
      } ${className && className}`}
      alternativeLabel
      activeStep={activeStep}
      connector={<CustomConnector type={type} />}
    >
      {steps}
    </Stepper>
  );
};

export default StepProgressBar;
